import SectionTitle from "components/Pages/Purchases_new/components/SectionTitle";
import { PurchaseStepE } from "components/Pages/Purchases_new/models/enums";
import { type Dispatch, memo, SetStateAction } from "react";
import ThanksBillingForm from "../ThanksBillingForm/ThanksBillingForm";

import styles from "../../paymentMethodSection.module.scss";

interface SecondStepSectionI {
  step: PurchaseStepE;
  setStep: Dispatch<SetStateAction<PurchaseStepE>>;
  isSecondStep: boolean;
  setIframeUrl: Dispatch<SetStateAction<string>>;
  transactionAmount: number;
}

const SecondStepSection = memo(
  ({
    step,
    setStep,
    isSecondStep,
    setIframeUrl,
    transactionAmount,
  }: SecondStepSectionI) => {
    return (
      <>
        <SectionTitle
          titleTextKey="billing-information-title"
          step={step}
          className={`${styles.customTitle}`}
        />
        <ThanksBillingForm
          step={step}
          setStep={setStep}
          isSecondStep={isSecondStep}
          setIframeUrl={setIframeUrl}
          transactionAmount={transactionAmount}
        />
      </>
    );
  }
);
export default SecondStepSection;
